function getResponse(res) {
  return {
    errCode: res.errCode,
    errMsg: res.errmsg,
    status: res.statusCode,
    body: res.body,
    headers: res.headers
  };
}
/**
* @description 传递手机qq的请求及返回结果
* @param {string} url
* @param {object} opt = {method,url,headers,body}
* @memberof module:wnscgi
*/


function wnsCgi(url, opt) {
  var wnsParams = {
    method: opt.method,
    url: url,
    headers: opt.headers,
    body: opt.body || ''
  }; // const startTime = Date.now();

  if (window.mqq) {
    window.mqq.invoke('edu', 'transferHttpRequest', wnsParams, function (res) {
      res = JSON.parse(res);

      if (res.errCode !== 0) {
        opt.error(res);
      } else {
        // 成功返回
        opt.success(getResponse(res));
      }
    });
  }
}

export { wnsCgi };